export default function GeneralIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={25}
      fill="none"
    >
      <path
        fill="#000"
        d="M21.25 5.875a1 1 0 1 1 0 2h-13a1 1 0 0 1 0-2h13ZM21.25 11.875a1 1 0 1 1 0 2h-13a1 1 0 1 1 0-2h13ZM21.25 17.875a1 1 0 1 1 0 2h-13a1 1 0 1 1 0-2h13ZM3.26 5.875a1 1 0 0 1 0 2h-.01a1 1 0 0 1 0-2h.01ZM3.26 11.875a1 1 0 1 1 0 2h-.01a1 1 0 1 1 0-2h.01ZM3.26 17.875a1 1 0 1 1 0 2h-.01a1 1 0 1 1 0-2h.01Z"
      />
    </svg>
  );
}
